// Browser polyfills
import 'whatwg-fetch';

// Libs
import React, { Fragment, useState } from 'react';
import ReactDOM from 'react-dom/client';

// Bridge
import { Bridge } from '@nackle/bridge';
import auth, { authRequestMiddleware, authRouteMiddleware } from './app-auth.js';
import { applyRequestMiddleware } from './fetch.js';

// Routing
import { Route, routeHistory, Link } from '@nackle/biw-web-router';
import { routes, bundleRoutingMiddleware } from './app-routing.jsx';

// Components
import { Layout, Menu } from 'antd';
import AppHeader from './components/app-header/header.jsx';

// Styles
import './styles/app.less';


/*******************************************************************************
 *  1. App (root level component)
 */

const App = () => {
    const { Header, Footer } = Layout;
    const [ user, setUser ] = useState( {} );

    const handleSignIn = async ( user ) => {
        setUser( user );
    };

    return (
        <Layout className='app-root'>

            <AppHeader />

            <Bridge
                autoSignIn={ true }
                auth={ auth }
                requiresAuth={ true }
                onSignIn={ handleSignIn }
                onRefresh={ handleSignIn } >

                <Header>
                    <div className="logo" />
                    <Menu theme="dark" mode="horizontal" defaultSelectedKeys={ [ '1' ] }>
                        <Menu.Item key="1">
                            <Link to="/home">Home</Link>
                        </Menu.Item>
                        <Menu.Item key="2">
                            <Link to="/about">About</Link>
                        </Menu.Item>
                        <Menu.Item key="3">
                            <Link to="/configure">Configure</Link>
                        </Menu.Item>
                    </Menu>
                </Header>

                <Route render={ ( route ) => {
                    document.title = route && route.match ? route.match.title : 'Some default page title';

                    return route.match &&
                        <Fragment>
                            { React.cloneElement( route.component, {
                                className: getRouteClassName( route.pathname, 'view' ),
                                user: user,
                                locale: 'en-US'
                            } ) }
                        </Fragment>;
                } }/>

            </Bridge>

            <Footer style={ { textAlign: 'center' } }>© { new Date().getFullYear() } BI WORLDWIDE™ All Rights Reserved.</Footer>

        </Layout>
    );

};

const getRouteClassName = ( pathname, prefix ) => {
    const classList = [ prefix ];

    // let prefix = '--';
    prefix = `${ prefix }-`;
    pathname.substring( 1 ).split( '/' ).forEach( ( part ) => {
        classList.push( `${ prefix }${ part }` );
        prefix = `${ prefix }${ part }-`;
    } );

    return classList.join( ' ' );
};

/*******************************************************************************
 *  2. Connect Routing
 */
routeHistory.applyRoutes( routes );
routeHistory.applyMiddleware( [ authRouteMiddleware, bundleRoutingMiddleware ] );

/*******************************************************************************
 *  3. Connect Auth to Fetch
 */
applyRequestMiddleware( authRequestMiddleware );


/*******************************************************************************
 * 4. Render
 */

const root = ReactDOM.createRoot( document.getElementById( 'app-root' ) );
root.render( <App /> );
